import { useEffect, useMemo } from 'react';
import { ImpressionArea } from '@toss/impression-area';
import { useTranslation } from 'next-i18next';
import { useSpaces } from '@zep/apis';
import { SpacesQuery } from '@zep/types';
import { useSearchFilterContext } from '../../../../contexts';
import Empty from '../../common/Empty';
import { NewSpaceCard } from './NewSpaceCard';
import S from './SpaceList.module.scss';
export const SpaceList = () => {
  const {
    t
  } = useTranslation(['home']);
  const {
    filterType,
    searchQuery,
    setIsShowSearchInput
  } = useSearchFilterContext();
  const {
    data: spaceResult,
    fetchNextPage,
    hasNextPage
  } = useSpaces({
    type: filterType,
    spaceName: searchQuery
  }, {
    limit: 24
  }, {
    suspense: true
  });
  const flattedSpaceResult = useMemo(() => spaceResult?.pages.flatMap(page => page.spaces) || [], [spaceResult]);
  const onImpressionStart = () => {
    if (hasNextPage) {
      fetchNextPage();
    }
  };
  useEffect(() => {
    if (spaceResult?.pages.length === 0) {
      setIsShowSearchInput(false);
    } else {
      setIsShowSearchInput(true);
    }
  }, [spaceResult?.pages.length, setIsShowSearchInput]);
  if (flattedSpaceResult?.length === 0) {
    return <div className={S.space_grid_wrapper}>
        <Empty image={{
        url: '/images/light/spaceMe/empty_with_character.png',
        width: 124,
        height: 148
      }} emptyItem={filterType === SpacesQuery.RECENT ? t('home:space_no_visited_space_placeholder') : t('home:space_no_related_space_placeholder')} useCustomMessage={true} />
      </div>;
  }
  return <div className={S.space_grid_wrapper} data-sentry-component="SpaceList" data-sentry-source-file="SpaceList.tsx">
      <div className={S.grid_inner}>
        {flattedSpaceResult?.map(space => <NewSpaceCard key={space.hashId} space={space} />)}
      </div>

      <ImpressionArea onImpressionStart={onImpressionStart} rootMargin={'300px'} data-sentry-element="ImpressionArea" data-sentry-source-file="SpaceList.tsx">
        <div />
      </ImpressionArea>
    </div>;
};